import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: "wbo-file-select",
    templateUrl: "./file-select.component.html",
    styleUrls: ["file-select.component.scss"]
})
export class FileSelectComponent {

    @Input() fileExtension: string = ".json";
    @Input() fileType: string = "application/json";

    /**
     * Emits the content of the file selected or undefined if there was no content
     */
    @Output() fileSelected: EventEmitter<any> = new EventEmitter();

    fileContent: any;
    fileName: string;


    readSingleFile(event): void {
        const file = event.target.files[0];
        if (!file) {
            return;
        }
        this.loadFile(event.target.files[0]);
    }

    loadFile(file: File): void {
        if (this.fileType && file.type !== this.fileType) {
            return;
        }
        const reader: FileReader = new FileReader();
        reader.onload = (e: Event) => {
            this.fileContent = e.target["result"];
            this.fileName = file.name;
            this.fileSelected.next(this.fileContent);
        };
        reader.readAsText(file);
    }

    dragover(event: DragEvent): void {
        event.stopPropagation();
        event.preventDefault();
    }

    drop(event: DragEvent): void {
        event.stopPropagation();
        event.preventDefault();
        if (event.dataTransfer.files && event.dataTransfer.files.length) {
            this.loadFile(event.dataTransfer.files[0]);
        }
    }
}
